import { render, staticRenderFns } from "./left4.vue?vue&type=template&id=7d5ba890&scoped=true&"
import script from "./left4.vue?vue&type=script&lang=js&"
export * from "./left4.vue?vue&type=script&lang=js&"
import style0 from "./left4.vue?vue&type=style&index=0&id=7d5ba890&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5ba890",
  null
  
)

export default component.exports